/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_norm_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find the normality of a concentrated liquid reagent from its density, assay and equivalent weight.`)
};

const es_norm_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcula la normalidad de un reactivo líquido concentrado a partir de su densidad, ensayo y peso equivalente.`)
};

const de_norm_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestimmen Sie die Normalität eines konzentrierten flüssigen Reagenzes aus Dichte, Gehalt und Äquivalentgewicht.`)
};

const nl_norm_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereken de normaliteit van een geconcentreerd vloeibaar reagens uit dichtheid, gehalte en equivalentgewicht.`)
};

const fr_norm_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trouvez la normalité d'un réactif liquide concentré à partir de sa densité, de son titre et de son équivalent-gramme.`)
};

const it_norm_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trova la normalità di un reagente liquido concentrato dalla sua densità, titolo e peso equivalente.`)
};

const pt_br2_norm_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encontre a normalidade de um reagente líquido concentrado a partir de sua densidade, teor e peso equivalente.`)
};

const pt_norm_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule a normalidade de um reagente líquido concentrado a partir da sua densidade, título e equivalente-grama.`)
};

const ja_norm_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密度、アッセイ値、当量から、濃縮液体試薬の規定度を求めます。`)
};

const zh_norm_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据密度、含量和当量重量求出浓缩液体试剂的当量浓度。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const norm_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.norm_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("norm_tool_description", locale)
	if (locale === "en") return en_norm_tool_description(inputs)
	if (locale === "es") return es_norm_tool_description(inputs)
	if (locale === "de") return de_norm_tool_description(inputs)
	if (locale === "nl") return nl_norm_tool_description(inputs)
	if (locale === "fr") return fr_norm_tool_description(inputs)
	if (locale === "it") return it_norm_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_norm_tool_description(inputs)
	if (locale === "pt") return pt_norm_tool_description(inputs)
	if (locale === "ja") return ja_norm_tool_description(inputs)
	return zh_norm_tool_description(inputs)
};